import { Select, SelectVariant, Switch } from '@focaldata/cin-ui-components'
import React from 'react'
import { QuestionSettingCode } from '../../../data/model/questionnaire'
import useSetQuestionnaireSetting from '../../../hooks/questionnaire/useSetQuestionnaireSetting'
import { getSettingValue } from '../../../utils/HelperFunctions'
import { WithEntry } from '../../../utils/questionnaireUtils'
import { BoolSettingToggler } from '../QuestionCardSwitches'
import useStyles from './Switches.styles'
import {
  SLIDER_INITIAL_PLACEMENT_SELECTOR,
  SliderInitialPlacement,
  sliderInitialPlacementOptions
} from './constants'

interface Props extends WithEntry {
  isSliderSwitchShowLabelsOn?: boolean
  onShowSliderLabels?: () => void
  onShowHideTracker?: () => void
  isSliderHideTrackerOn?: boolean
  onHideSelectedValue?: () => void
  isSliderHideSelectedValueOn?: boolean
  sliderInitialPlacement?: SliderInitialPlacement
  onChangeSliderInitialPlacement?: (
    settingValue: SliderInitialPlacement
  ) => void
}

const SliderSwitches: React.FC<Props> = (props: Props) => {
  const {
    entry,
    isSliderSwitchShowLabelsOn,
    onShowSliderLabels,
    onShowHideTracker,
    isSliderHideTrackerOn,
    onHideSelectedValue,
    isSliderHideSelectedValueOn,
    sliderInitialPlacement = SliderInitialPlacement.MIDDLE,
    onChangeSliderInitialPlacement
  } = props
  const { handleSettingChange } = useSetQuestionnaireSetting(entry)
  const showLabelsText = 'Show labels'
  const hideTrackerText = 'Hide fill bar'
  const hideSelectedValueText = 'Hide numbers'
  const { classes } = useStyles()

  const handleShowSliderLabels: BoolSettingToggler = (settingValue) => {
    if (onShowSliderLabels) {
      onShowSliderLabels()
    }
    handleSettingChange(
      [{ settingCode: QuestionSettingCode.SliderLabels, settingValue }],
      'no-cache'
    )
  }

  const handleShowHideTracker: BoolSettingToggler = (settingValue) => {
    if (onShowHideTracker) {
      onShowHideTracker()
    }
    handleSettingChange(
      [{ settingCode: QuestionSettingCode.HideTracker, settingValue }],
      'no-cache'
    )
  }

  const handleHideSelectedValue: BoolSettingToggler = (settingValue) => {
    if (onHideSelectedValue) {
      onHideSelectedValue()
    }
    handleSettingChange(
      [
        {
          settingCode: QuestionSettingCode.HideSelectedSliderValue,
          settingValue
        }
      ],
      'no-cache'
    )
  }

  return (
    <div className="fd-grid fd-container fd-row">
      <Switch
        first
        checked={isSliderSwitchShowLabelsOn}
        onChange={(event) => {
          const settingValue = getSettingValue(event.target.checked)
          handleShowSliderLabels(settingValue)
        }}
        label={showLabelsText}
        id="show-labels-switch"
      />
      <Switch
        first
        checked={isSliderHideTrackerOn}
        onChange={(event) => {
          const settingValue = getSettingValue(event.target.checked)
          handleShowHideTracker(settingValue)
        }}
        label={hideTrackerText}
        id="hide-tracker-switch"
      />
      <Switch
        first
        checked={isSliderHideSelectedValueOn}
        onChange={(event) => {
          const settingValue = getSettingValue(event.target.checked)
          handleHideSelectedValue(settingValue)
        }}
        label={hideSelectedValueText}
        id="hide-selected-value-switch"
      />
      <div className={classes.selectContainer}>
        <Select
          ariaLabel={SLIDER_INITIAL_PLACEMENT_SELECTOR}
          variant={SelectVariant.Filled}
          optionValue={sliderInitialPlacement}
          options={sliderInitialPlacementOptions}
          optionPrefix="Starting position"
          onChange={(event) => {
            if (onChangeSliderInitialPlacement) {
              const eventValue = event.target.value as SliderInitialPlacement
              onChangeSliderInitialPlacement(eventValue)
            }
          }}
        />
      </div>
    </div>
  )
}

export default SliderSwitches
